import classNames from 'classnames';
import React from 'react';
import { Tracker } from '@udemy/event-tracking';
import { useI18n } from '@udemy/i18n';
import { Icon } from '@udemy/icons';
import { Popover } from '@udemy/react-popup-components';
import { LEARNING_PATH_ICON } from '../constants';
import { LearningPathPresented, LearningPathSelected } from '../events';
import { ProCertificationBadge } from '../pro-certification-badge/pro-certification-badge.react-component';
import { ProContentCard } from '../pro-content-card/pro-content-card.react-component';
import styles from "./pro-learning-path-card.module.css";
export const ProLearningPathCard = ({
  proLearningPath,
  uiRegion,
  searchTrackingId,
  serveTrackingId
}) => {
  var _proLearningPath$badg;
  const {
    gettext
  } = useI18n();
  const type = 'udemyPath';
  const badge = (_proLearningPath$badg = proLearningPath.badges) === null || _proLearningPath$badg === void 0 ? void 0 : _proLearningPath$badg[0];
  const eventLearningPath = {
    id: proLearningPath.id,
    isPublicLearningPath: true,
    isUdemyPath: true
  };
  function onClick() {
    Tracker.publishEvent(new LearningPathSelected(eventLearningPath, uiRegion, proLearningPath.topicIds, searchTrackingId, serveTrackingId));
  }
  function onPresented() {
    Tracker.publishEvent(new LearningPathPresented(eventLearningPath, uiRegion, proLearningPath.topicIds, searchTrackingId, serveTrackingId));
  }
  const proContentCard =
  /*#__PURE__*/
  // div necessary for popover to work properly
  React.createElement("div", {
    className: styles['pro-content-card-wrapper']
  }, /*#__PURE__*/React.createElement(ProContentCard, {
    iconName: LEARNING_PATH_ICON,
    ctaUrl: proLearningPath.urlLanding,
    onClick: onClick,
    onPresented: onPresented,
    type: type,
    title: proLearningPath.title
  }, /*#__PURE__*/React.createElement(ProCertificationBadge, {
    badge: badge
  })));
  const popoverContent = /*#__PURE__*/React.createElement("div", {
    className: classNames(styles['hover-content'])
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "info",
    label: false,
    size: "xlarge",
    color: "info"
  }), /*#__PURE__*/React.createElement("span", {
    className: "ud-heading-md"
  }, gettext("You're enrolled in this path")));
  return proLearningPath.isEnrolled ? /*#__PURE__*/React.createElement(Popover, {
    className: styles['pro-content-card-wrapper'],
    trigger: proContentCard,
    withArrow: true,
    canToggleOnHover: true,
    detachFromTarget: true,
    placement: "bottom"
  }, popoverContent) : proContentCard;
};
//# sourceMappingURL=pro-learning-path-card.react-component.js.map